// const baseUrl = "http://192.168.40.147:8118/"; // 本地
const baseUrl = "http://api.zyzxgc.cn/api/"; // 在线
export const ip = baseUrl; //生产地址
export const codeURL = ip + "index/loginAdmin/getVerify"; // 登录图形验证码
// export const URL = "http://192.168.40.147:8118/static/"; // 图片地址前缀
export const URL = "http://api.zyzxgc.cn/file/"; // 图片地址前缀
export const uploadURL = ip + "web/file/upload"; // 上传地址
